if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.submitButton && this.submitButtonText) {
  this.submitButton.setAttribute(
    'data-default-text',
    this.submitButtonText.textContent.trim()
  );
}


        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

toggleSubmitButton(disable = true, text) {
  if (!this.submitButton) return;

  this.submitButton.toggleAttribute('disabled', disable);
  this.submitButton.setAttribute('aria-disabled', disable ? 'true' : 'false');

  if (this.submitButtonText && typeof text === 'string') {
    this.submitButtonText.textContent = text;
  }

  if (!disable && this.submitButtonText && !text) {
    const defaultText =
      this.submitButton.getAttribute('data-default-text') ||
      window.variantStrings?.addToCart ||
      'Add to cart';

    this.submitButtonText.textContent = defaultText;
  }

  this.submitButton.classList.toggle('disabled', disable);
}


      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            this.error = false;

            // ✅ Let Dawn update cart state
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // ✅ Update cart count
            updateCartCount();

            // ✅ SHOW POPUP (inline, guaranteed)
            showAddToBagPopupFromVariant(formData.get('id'));
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* --------------------------------------------------------------------------
  Cart count updater (unchanged)
--------------------------------------------------------------------------- */
const updateCartCount = async () => {
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());

    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    if (cart.item_count > 0) {
      bubble.classList.remove('hidden');
      bubble.querySelector('[aria-hidden="true"]').textContent = cart.item_count;
      bubble.querySelector('.visually-hidden').textContent =
        `${cart.item_count} items`;
    } else {
      bubble.classList.add('hidden');
    }
  } catch (e) {
    console.error('Cart count update failed', e);
  }
};

/* --------------------------------------------------------------------------
  Color contrast helpers
--------------------------------------------------------------------------- */
const getContrastTextColor = (hex) => {
  if (!hex || hex === 'transparent') return '#000000';

  let c = hex.replace('#', '');

  // Expand shorthand (#abc → #aabbcc)
  if (c.length === 3) {
    c = c.split('').map((x) => x + x).join('');
  }

  const r = parseInt(c.substr(0, 2), 16) / 255;
  const g = parseInt(c.substr(2, 2), 16) / 255;
  const b = parseInt(c.substr(4, 2), 16) / 255;

  // Convert to linear RGB
  const toLinear = (v) =>
    v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);

  const luminance =
    0.2126 * toLinear(r) +
    0.7152 * toLinear(g) +
    0.0722 * toLinear(b);

  // WCAG-recommended midpoint
  return luminance > 0.55 ? '#000000' : '#ffffff';
};


/* --------------------------------------------------------------------------
  Variant → color + sticky ATC logic (PRESERVED)
--------------------------------------------------------------------------- */
subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  if (!data || !data.variant || !data.sectionId) return;

  const { variant, sectionId } = data;

  const mapEl = document.getElementById(
    `ProductColorSwatchMap-${sectionId}`
  );

  if (!mapEl) return;

  const colorMap = JSON.parse(mapEl.textContent);

  const color =
    colorMap[variant.option1] ||
    colorMap[variant.option2] ||
    colorMap[variant.option3] ||
    'transparent';

  // 🌍 GLOBAL variable
const textColor = getContrastTextColor(color);

document.body.style.setProperty('--active-variant-color', color);
document.body.style.setProperty('--active-variant-text-color', textColor);

});


subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  if (!data || !data.variant || !data.sectionId) return;

  const { variant, sectionId } = data;

  const priceEl = document.getElementById(
    `StickyAtcPrice-${sectionId}`
  );
  const colorLabel = document.getElementById(
    `StickyAtcColor-${sectionId}`
  );
  const button = document.getElementById(
    `StickyAtcButton-${sectionId}`
  );

  if (colorLabel) {
    colorLabel.textContent =
      variant.option1 || variant.option2 || variant.option3 || '';
  }

  if (button) {
    button.disabled = !variant.available;
  }
});

/* --------------------------------------------------------------------------
  Sticky ATC wiring (PRESERVED)
--------------------------------------------------------------------------- */
const setupStickyAtcVisibility = (sectionId) => {
  const stickyAtc = document.getElementById(`StickyAtc-${sectionId}`);
  const mainAtc = document.querySelector(
    `#ProductInfo-${sectionId} [type="submit"][name="add"]`
  );

  if (!stickyAtc || !mainAtc) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      stickyAtc.toggleAttribute('hidden', entry.isIntersecting);
    },
    { rootMargin: '-80px 0px 0px 0px' }
  );

  observer.observe(mainAtc);
};

const setupStickyAtcButton = (sectionId) => {
  const button = document.getElementById(`StickyAtcButton-${sectionId}`);
  const mainForm = document.querySelector(
    `#product-form-${sectionId} form`
  );

  if (!button || !mainForm) return;

  button.addEventListener('click', () => {
    mainForm.requestSubmit();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const sectionId = document
    .querySelector('[data-section]')
    ?.getAttribute('data-section');

  if (!sectionId) return;

  setupStickyAtcVisibility(sectionId);
  setupStickyAtcButton(sectionId);
});




/* --------------------------------------------------------------------------
  ADD-TO-BAG POPUP (INLINE, GUARANTEED)
--------------------------------------------------------------------------- */
const showAddToBagPopupFromVariant = async (variantId) => {
  const popup = document.getElementById('AddToBagPopup');
  if (!popup) return;

  const img = popup.querySelector('img');
  const titleEl = popup.querySelector('.add-to-bag-popup__title');
  const optionsEl = popup.querySelector('.add-to-bag-popup__options');
  const subtotalEl = popup.querySelector(
    '.add-to-bag-popup__subtotal-price'
  );
  const closeBtn = popup.querySelector('.add-to-bag-popup__close');
  const viewCartBtn = popup.querySelector('.add-to-bag-popup__view-cart');

  closeBtn.onclick = () => popup.setAttribute('hidden', true);
  viewCartBtn.onclick = () => {
    popup.setAttribute('hidden', true);
    document.querySelector('cart-drawer')?.open();
  };

  try {
    const cart = await fetch('/cart.js').then((r) => r.json());

    const item = cart.items.find(
      (i) => i.variant_id === Number(variantId)
    );
    if (!item) return;

    img.src = item.image;
    img.alt = item.product_title;
    titleEl.textContent = item.product_title;

    optionsEl.innerHTML = '';
    item.options_with_values.forEach((opt) => {
      const li = document.createElement('li');
      li.textContent = `${opt.name}: ${opt.value}`;
      optionsEl.appendChild(li);
    });

    subtotalEl.textContent = formatMoneySafe(cart.items_subtotal_price);


    popup.removeAttribute('hidden');
  } catch (e) {
    console.error('Add-to-bag popup failed', e);
  }
};
